module.exports = __webpack_public_path__ + "static/p07_borreguitoLLegBackLTop-8b23876114bc88ed593b75aeb4932b5d.png";